import styled from 'styled-components';
import Label from 'components/atoms/inputs/Label';

const PaddedLabel = styled(Label)`
    display: flex;
    align-items: center;
    height: 24px;
`;

export default PaddedLabel;



// WEBPACK FOOTER //
// ./src/components/molecules/PaddedLabel.js